(() => {
const $d5fd42aa95e2df49$export$e14d3bc873a8b9b1 = ()=>{
    const modalTriggers = document.querySelectorAll(".modalTrigger");
    modalTriggers.forEach((trigger)=>{
        trigger.addEventListener("click", (event)=>{
            const modalId1 = trigger.getAttribute("data-modal-id");
            $d5fd42aa95e2df49$export$a7f6cffb6b8ba11c(modalId1, event);
        });
    });
};
const $d5fd42aa95e2df49$export$a7f6cffb6b8ba11c = (modalId1, event)=>{
    if (!modalId1) return;
    if (event) event.preventDefault();
    const modal = document.getElementById(modalId1);
    if (!modal) return;
    const onTransitionEnd = ()=>{
        modal.removeEventListener("transitionend", onTransitionEnd);
        modal.close();
    };
    const closeButtons = modal.querySelectorAll(".close");
    closeButtons.forEach((closeButton)=>{
        closeButton.addEventListener("click", ()=>{
            modal.addEventListener("transitionend", onTransitionEnd);
            modal.classList.remove("active");
        });
    });
    // Add the event listener for transitionend
    modal.showModal();
    modal.classList.add("active");
};
const $d5fd42aa95e2df49$export$be9f690f4dcf1fe3 = ()=>{
    // @ts-ignore
    if (typeof modalId === "undefined") return;
    // @ts-ignore
    $d5fd42aa95e2df49$export$a7f6cffb6b8ba11c(modalId);
};
$d5fd42aa95e2df49$export$e14d3bc873a8b9b1();
$d5fd42aa95e2df49$export$be9f690f4dcf1fe3();

})();
//# sourceMappingURL=main.js.map
